import React, { useState } from 'react';
import { InfoOutlined } from '@material-ui/icons';

import { CardTitle } from 'components/common';
import { ShowLayout } from 'components/details';
import InterceptionActions from './InterceptionActions';
import InterceptionDialog from './InterceptionDialog';
import InterceptionSection from './InterceptionSection';

const InterceptionCard = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ShowLayout when={(record) => record?.deliveryProvider?.code === 'UPS'}>
      <CardTitle icon={<InfoOutlined />} actions={<InterceptionActions onEdit={handleOpen} />}>
        Interception
      </CardTitle>
      <InterceptionSection />
      {open && <InterceptionDialog onClose={handleClose} />}
    </ShowLayout>
  );
};

export default InterceptionCard;
